import { useHistory as useHistoryDOM } from 'react-router-dom';

import { rewrite, rewriteInverse } from './rewrite';

export function useRewrite(): (path: string, invert?: boolean) => string {
	const history = useHistoryDOM();

	return (path: string, invert?: boolean) => {
		const query = path.includes('?') ? path.substring(path.indexOf('?')) : '';

		path = path.split('?')[0];

		if (path.startsWith('/v2/')) {
			path = path.substring(3);
		}

		if (history.location.pathname.startsWith('/v2') !== (invert ?? false)) {
			return rewrite(path) + query;
		} else {
			return rewriteInverse(path) + query;
		}
	};
}

export function useHistory() {
	const history = useHistoryDOM();
	const rewrite = useRewrite();

	const rewriteLocation = (location: string | object, invert?: boolean): string | object => {
		if (typeof location === 'string') {
			return rewrite(location, invert);
		} else {
			const { pathname, ...rest } = location as { pathname: string };

			return {
				pathname: rewrite(pathname, invert),
				...rest,
			};
		}
	};

	return {
		...history,
		push: (path: string | object, invert?: boolean) => history.push(rewriteLocation(path, invert)),
		replace: (path: string | object, invert?: boolean) =>
			history.replace(rewriteLocation(path, invert)),
	};
}
